import Vue from 'vue'
import InfiniteLoading from 'vue-infinite-loading'
import { mapActions, mapMutations, mapState } from 'vuex'
import { ModerationStages } from '@/constants/backend/ModerationStages'
import { STAGE_NEW, STAGE_STARTED } from '@/constants/job/jobStages'
import responseMixin from '@/mixins/responseMixin'
import unreadMessagesBlinkTitleMixin from '@/mixins/unreadMessagesBlinkTitleMixin'
import MyCustomerJobListItem from '@/models-ts/job/MyCustomerJobListItem'
import JobActiveCardCustomer from '@/partials/JobCards/JobActiveCardCustomer/JobActiveCardCustomer.vue'
import JobPostedCardCustomer from '@/partials/JobCards/JobPostedCardCustomer/JobPostedCardCustomer.vue'

const DATA_LIMIT = 20

export default Vue.extend<any, any, any>({
  mixins: [responseMixin, unreadMessagesBlinkTitleMixin],
  components: {
    JobPostedCardCustomer,
    JobActiveCardCustomer,
    InfiniteLoading,
  },
  data() {
    return {
      infiniteId: 0,
      totalLoading: false,
    }
  },
  computed: {
    ...mapState({
      jobs: (state: any) => state.myJobs.clientAll.values,
      isLoading: (state: any) => state.myJobs.clientAll.isLoading,
      isLoaded: (state: any) => state.myJobs.clientAll.isLoaded,
      pagination: (state: any) => state.myJobs.clientAll.pagination,
    }),
  },
  async created() {
    await this.load({ limit: DATA_LIMIT, offset: 0 })
    this.infiniteId = +new Date()
  },
  methods: {
    ...mapMutations({
      updateJobStatus: 'myJobs/updateJobStatus',
    }),
    ...mapActions({
      load: 'myJobs/loadClientAll',
      loadMore: 'myJobs/loadMoreClientAll',
    }),
    isActive(job: MyCustomerJobListItem) {
      return job.stage !== STAGE_NEW && job.stage !== STAGE_STARTED
    },
    async onLoadMore($state: any) {
      try {
        if (this.jobs.length < this.pagination.total) {
          this.totalLoading = true
          await this.loadMore({ limit: DATA_LIMIT, offset: this.jobs.length })
          return $state.loaded()
        }
        return $state.complete()
      } catch (e) {
        this.parseError(e)
      } finally {
        this.totalLoading = false
      }
    },
    async onResetJobs() {
      await this.load()
      this.infiniteId = +new Date()
      this.offset = 0
    },
    onChangeStatus({ jobId, status, moderationStage }: { status: any; moderationStage: ModerationStages; jobId: number }) {
      this.updateJobStatus({ jobId, status, moderationStage })
    },
  },
  metaInfo() {
    return {
      title: this.getMetaTitle('My Jobs - All'),
    }
  },
})
